import { isPastDue } from '@/lib/dates';
import type { SpecRow } from '@/types/database';

/**
 * Statuses that mean the material has already arrived or been dropped — a
 * delivery date in the past is expected for these, not a problem.
 */
const NOT_OVERDUE_STATUSES: ReadonlySet<SpecRow['status']> =
  new Set(['installed', 'delivered', 'rejected']);

/**
 * Is a material past its estimated delivery date and still outstanding?
 *
 * Note `isPastDue` (not `new Date(iso) < today`) — estimated_delivery is a
 * date-only column, and the naive comparison flagged materials due TODAY as
 * overdue in every timezone west of UTC. See @/lib/dates.
 */
export function isSpecOverdue(s: Pick<SpecRow, 'status' | 'estimated_delivery'>,
                              today: Date = new Date()): boolean {
  if (NOT_OVERDUE_STATUSES.has(s.status)) return false;
  return isPastDue(s.estimated_delivery, today);
}
